import FieldFormTemplateModule from './fields.form.template';





export default FieldFormTemplateModule.extend( {

    template: 'module/refbooks/fields.form.nested-fields',

    url() {
        return this.model.id
            ? `fields/${this.model.id}/edit/nested-fields`
            : `fields/new/nested-fields`;
    },

    open({ field, original }) {
        const {
            fieldsPage = 1, fieldsLimit = 10,
            fieldsSort = 'name', fieldsDirection = 'asc',
            fieldsSearch = '',
        } = this.state() || {};

        this.setState( { 
            fieldsPage, fieldsLimit, fieldsSort, fieldsDirection, fieldsSearch,
        } );

        return FieldFormTemplateModule.prototype.open.call( this, { field, original } );
    },

    finalizeOpen(field) {
        return this.bind( field );
    },

    finalizeStart(field) {
        this.listenTo( field, 'change:cluster', () => {
            this.setState( { page: 1, } ), this.navigated();
            // no need to change fields' page and rerender grid here -
            // they share the same parent field's cluster anyway 
        } );

        this.listenTo( field, 'change:format', () => {
            if (field.get( 'format' ) !== 'composite' )
                this.setState( { fieldsPage: 1, fieldsSearch: '', fieldsSort: 'name', fieldsDirection: 'asc' } ),
                this.trigger( FieldFormTemplateModule.TOGGLE_BOUND_TYPES,
                    this.model,
                    this.originalModel,
                    this.state() );
        } );
    },

    serialize() {
        const { 
            fieldsSort, fieldsDirection, fieldsSearch, fieldsPage
        } = this.state();

        return {
            fieldsSort, fieldsDirection, fieldsSearch, fieldsPage, 
            hasDiff: () => this.hasDiff(),
        };
    },

    [FieldFormTemplateModule.event( 'Subfields:page')](page) {
        return this.setState( { fieldsPage: +page, } ), 
            this.navigated();
    },

    [FieldFormTemplateModule.event( 'Subfields:sort')]({ sort, direction }) {
        return this.setState( { fieldsSort: sort, fieldsDirection: direction, } ), 
            this.navigated();
    },

    [FieldFormTemplateModule.event( 'Subfields:search')](search) {
        return this.setState( { fieldsSearch: search, fieldsPage: 1, } ), 
            this.navigated();
    },

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/fields.form.nested-fields.js